import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import COUNTRY_CODE_OPTIONS from './CountryCodeOptions';
import COUNTRIES from '../../data/countries';

const PersonalInfoFields = ({ formData, onInputChange, isSubmitting }) => (
  <>
    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="first_name">First Name *</Label>
        <Input id="first_name" placeholder="John" value={formData.first_name}
          onChange={(e) => onInputChange('first_name', e.target.value)} disabled={isSubmitting} required />
      </div>
      <div className="space-y-2">
        <Label htmlFor="last_name">Last Name *</Label>
        <Input id="last_name" placeholder="Doe" value={formData.last_name}
          onChange={(e) => onInputChange('last_name', e.target.value)} disabled={isSubmitting} required />
      </div>
    </div>

    <div className="space-y-2">
      <Label htmlFor="email">Email Address *</Label>
      <Input id="email" type="email" placeholder="john.doe@example.com" value={formData.email}
        onChange={(e) => onInputChange('email', e.target.value)} disabled={isSubmitting} required />
    </div>

    <div className="space-y-2">
      <Label htmlFor="country">Country *</Label>
      <Select value={formData.country} onValueChange={(value) => onInputChange('country', value)} disabled={isSubmitting}>
        <SelectTrigger data-testid="access-request-country-select">
          <SelectValue placeholder="Select your country" />
        </SelectTrigger>
        <SelectContent className="max-h-[300px]">
          {COUNTRIES.map(c => (<SelectItem key={c} value={c}>{c}</SelectItem>))}
        </SelectContent>
      </Select>
      <p className="text-xs text-gray-500">We use this for currency, time zone and reporting defaults.</p>
    </div>

    <div className="space-y-2">
      <Label htmlFor="phone_number">Phone Number</Label>
      <div className="flex gap-2">
        <Select value={formData.phone_country_code} onValueChange={(value) => onInputChange('phone_country_code', value)} disabled={isSubmitting}>
          <SelectTrigger className="w-[140px]"><SelectValue placeholder="Country" /></SelectTrigger>
          <SelectContent className="max-h-[300px]">
            {COUNTRY_CODE_OPTIONS.map(opt => (
              <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Input id="phone_number" type="tel" placeholder="555-123-4567" value={formData.phone_number}
          onChange={(e) => onInputChange('phone_number', e.target.value)} disabled={isSubmitting} className="flex-1" />
      </div>
    </div>

    <div className="border-t pt-4 mt-6">
      <h3 className="text-lg font-semibold mb-4 text-gray-900">Professional Background</h3>
      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="occupation">Occupation/Role</Label>
          <Input id="occupation" placeholder="e.g. Software Engineer, Financial Advisor" value={formData.occupation}
            onChange={(e) => onInputChange('occupation', e.target.value)} disabled={isSubmitting} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="linkedin_profile">LinkedIn Profile (Optional)</Label>
          <Input id="linkedin_profile" type="url" placeholder="https://linkedin.com/in/yourprofile" value={formData.linkedin_profile}
            onChange={(e) => onInputChange('linkedin_profile', e.target.value)} disabled={isSubmitting} />
        </div>
      </div>
    </div>
  </>
);

export default PersonalInfoFields;
